// https://www.viestintavirasto.fi/attachments/maaraykset/Viestintavirasto32R2014M_EN.pdf
// https://www.itu.int/dms_pub/itu-t/oth/02/02/T02020000490003PDFE.pdf
// (note that minimum length in document is for new numbers, minimum is 5 digits for old numbers)

import { finnishCountryCodeString } from "./finnishCountryCode";

export const finnishAreaMobile = new RegExp(`^(${finnishCountryCodeString})[1-9](\\d{4,11})$`);